import React, { useState, useCallback, useMemo } from "react";
import { Modal, Typography } from "@ann/web-components";
import { useMediaQueries } from "../../../../../utils/mediaQueries";
import { DescriptionText } from "./DeleteConversationModal.styled";

const DeleteConversationModal = ({
  isOpen,
  onClose,
  onConfirm,
  conversationId = null,
  isLoading = false,
  modalWidth = "900px",
  size = "medium",
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { isMobile, isIpadAirPortrait, isIpadAirLandscape, isIpadProPortrait, isIpadProLandscape } =
    useMediaQueries();

  const isIpad = isIpadAirPortrait || isIpadAirLandscape || isIpadProPortrait || isIpadProLandscape;

  const responsiveWidth = useMemo(() => {
    if (isMobile) return "90%";
    if (isIpad) return "80%";
    return modalWidth;
  }, [isMobile, isIpad, modalWidth]);

  const loading = isLoading || isDeleting;

  const handleConfirm = useCallback(async () => {
    if (!onConfirm || !conversationId) return;
    setIsDeleting(true);
    try {
      await onConfirm(conversationId);
    } catch (err) {
      // Error already shown via toast in hook
    } finally {
      setIsDeleting(false);
      onClose?.();
    }
  }, [conversationId, onConfirm, onClose]);

  const handleClose = useCallback(() => {
    if (!loading) onClose?.();
  }, [onClose, loading]);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width={responsiveWidth} size={size} zIndex={99999999}>
      <Modal.Header/>
      <Modal.Body>
        <DescriptionText>
          <Typography category="title" size="medium" weight="bold">Are you sure you want to delete this chat?</Typography>

          <Typography category="body" size="medium" weight="regular" color="body">
            Once deleted, you won&apos;t be able to access it again.<br/> If you&apos;re just cleaning up,
            consider renaming or archiving instead.
          </Typography>

        </DescriptionText>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button label="Cancel" onClick={handleClose} type="secondary" disabled={loading} />
        <Modal.Button
          label={loading ? "Deleting..." : "Delete"}
          onClick={handleConfirm}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteConversationModal;
